import BasicModal from "@/components/core/modals/BasicModal";
import { Document, Signatory } from "@/type/core/dashboard/dashboard.types";
import { CertificateInformationEnum } from "@/utils/enums/CertificateInformationEnum";
import { SignaturePatternEnum } from "@/utils/enums/signature/signature.pattern.enum";
import parse from "html-react-parser";
import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

interface DetailSignatoryProps {
  signatory: Signatory;
  documents: Document[];
  activateSignLevel2: boolean;
}

const DetailSignatory: FunctionComponent<DetailSignatoryProps> = ({
  signatory,
  documents,
  activateSignLevel2,
}) => {
  const { t } = useTranslation();

  const email = signatory.email;
  const certificate = signatory.certificate;
  const withCertificate = signatory.withCertificate;
  const pattern = (
    documents
      .flatMap((doc) => doc.signatures)
      .find((sig) => sig.email === email) || {}
  ).pattern;
  const isPatternWithoutLogo: boolean =
    pattern === SignaturePatternEnum.SIGN_WITHOUT_LOGO;
  const signed = signatory.status === "signed";

  const [modal, setModal] = useState<string | undefined>();

  return (
    <div data-test="table-item">
      {activateSignLevel2 && (
        <td key="certificate">
          {certificate &&
            certificate ===
              CertificateInformationEnum.REVOKED_JSE_CERTIFICATE && (
              <div
                className="d-flex justify-content-start"
                onClick={() => setModal("jseRevokedCertificate")}
                data-cell-alt="jse_revoked_certificate"
              >
                <span>
                  {t("account.mySignature.certificate.certificateLevelNames.2")}
                </span>
              </div>
            )}
          {(pattern === SignaturePatternEnum.SIGN_LEVEL_2_EC ||
            isPatternWithoutLogo) &&
            certificate &&
            certificate !==
              CertificateInformationEnum.REVOKED_JSE_CERTIFICATE && (
              <div
                className="d-flex justify-content-start"
                onClick={() => setModal("jseValidCertificate")}
                data-cell-alt="jse_certificate"
              >
                <span>
                  {t("account.mySignature.certificate.certificateLevelNames.2")}
                </span>
              </div>
            )}
          {!pattern &&
            certificate &&
            certificate === CertificateInformationEnum.JSE_CERTIFICATE && (
              <div
                className="d-flex justify-content-start"
                onClick={() => setModal("jseValidCertificate")}
                data-cell-alt="jse_certificate"
              >
                <span>
                  {t("account.mySignature.certificate.certificateLevelNames.2")}
                </span>
              </div>
            )}
          {pattern !== SignaturePatternEnum.SIGN_LEVEL_2_EC &&
            !isPatternWithoutLogo &&
            certificate &&
            certificate ===
              CertificateInformationEnum.PROGRESS_JSE_CERTIFICATE && (
              <div
                className="d-flex justify-content-start"
                onClick={() => setModal("jseMember")}
                data-cell-alt="jse_member"
              >
                <span>
                  {t("account.mySignature.certificate.certificateLevelNames.1")}
                </span>
              </div>
            )}
          {pattern === SignaturePatternEnum.SIGN_LEVEL_QCP_EC &&
            certificate &&
            certificate === CertificateInformationEnum.QCP_CERTIFICATE && (
              <div
                className="d-flex justify-content-start"
                onClick={() => setModal("usValidQCPCertificate")}
                data-cell-alt="us_qcp_valid_certificate"
              >
                <span>
                  {t("account.mySignature.certificate.certificateLevelNames.3")}
                </span>
              </div>
            )}
          {pattern !== SignaturePatternEnum.SIGN_LEVEL_2_EC &&
            !isPatternWithoutLogo &&
            signed &&
            withCertificate && (
              <div
                className="d-flex justify-content-start"
                onClick={() => setModal("usValidCertificate")}
                data-cell-alt="us_valid_certificate"
              >
                <span>
                  {t("account.mySignature.certificate.certificateLevelNames.2")}
                </span>
              </div>
            )}
          {pattern !== SignaturePatternEnum.SIGN_LEVEL_2_EC &&
            !isPatternWithoutLogo &&
            !signed &&
            !certificate &&
            withCertificate && (
              <div
                className="d-flex justify-content-start"
                onClick={() => setModal("askUsProgressCertificate")}
                data-cell-alt="ask_us_certificate"
              >
                <span>
                  {t("account.mySignature.certificate.certificateLevelNames.2")}
                </span>
              </div>
            )}
          {pattern !== SignaturePatternEnum.SIGN_LEVEL_2_EC &&
            !isPatternWithoutLogo &&
            !signed &&
            certificate &&
            certificate === CertificateInformationEnum.VALID_US_CERTIFICATE &&
            withCertificate && (
              <div
                className="d-flex justify-content-start"
                onClick={() => setModal("usValidCertificate")}
                data-cell-alt="us_valid_certificate"
              >
                <span>
                  {t("account.mySignature.certificate.certificateLevelNames.2")}
                </span>
              </div>
            )}
          {pattern !== SignaturePatternEnum.SIGN_LEVEL_2_EC &&
            pattern !== SignaturePatternEnum.SIGN_LEVEL_QCP_EC &&
            !isPatternWithoutLogo &&
            !withCertificate &&
            certificate !==
              CertificateInformationEnum.PROGRESS_JSE_CERTIFICATE &&
            certificate !== CertificateInformationEnum.JSE_CERTIFICATE &&
            certificate !== CertificateInformationEnum.QCP_CERTIFICATE &&
            certificate !==
              CertificateInformationEnum.REVOKED_JSE_CERTIFICATE && (
              <div
                className="d-flex justify-content-start"
                data-cell-alt="certificate_level_1"
              >
                <span>
                  {t("account.mySignature.certificate.certificateLevelNames.1")}
                </span>
              </div>
            )}
        </td>
      )}
      <BasicModal
        visible={modal !== undefined}
        onCancel={() => setModal(undefined)}
        onOk={() => setModal(undefined)}
        closable={false}
        showCancelButton={false}
        footerTakeAllWidth
        title={
          <>
            <span>{t(`modals.info.${modal}.title`)}</span>
          </>
        }
        className="app-modal-info"
      >
        <>{parse(t("modals.info." + modal + ".body"))}</>
      </BasicModal>
    </div>
  );
};

export default DetailSignatory;
